import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import history from '@/utils/history';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import '@/styles/index.scss';
import './index.css';
import './swiper.css';
import './navigation.css';
import './pagination.css';
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <HistoryRouter history={history}>
    <App />
  </HistoryRouter>
);
